import React, { useEffect, useState } from "react";
import Heading from "../../common/heading/Heading";
import "./Hero.css";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(false);
  const hasToken = !!localStorage.getItem("authToken");

  useEffect(() => {
    const savedMode = localStorage.getItem("darkMode");
    setDarkMode(savedMode === "true");
  }, []);

  return (
    <section className={`hero-wrapper ${darkMode ? "dark-mode" : ""}`}>
      {/* 1. الخلفية */}
      <div className="hero-background"></div>

      {/* 2. العناصر الطائرة في الشاشة كلها */}
      <div className="flying-elements">
        <span className="book">Edu Masr</span>
        <span className="book">Edu Masr</span>
      </div>

      {/* 3. حاوية المحتوى (Flexbox) */}
      <div className="container hero-container">
        
        {/* الجزء الأيمن: النصوص والأزرار */}
        <div className="hero-text-content">
       
          <div className="hero-buttons">

{!hasToken 
? 
(
  <button className="primary-btn" onClick={() => navigate("/Login")}>
    انضم الآن <i className="fa fa-long-arrow-alt-left"></i>
  </button>
  ) 
  : 
  (
    <button onClick={() => navigate("/Teachers")} className="btn login">
      مدرسيني
    </button>
    
  )}
</div>
        </div>

        {/* الجزء الأيسر: الصورة والإطار الزجاجي */}
      

      </div>
    </section>
  );
};

export default Hero;